import React, { useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import ThreeRender from "./components_3D/ThreeRender";
import Layout from "./pages/layout";
import Home from "./pages/home";
import RenderSelector from "./components/RenderSelector";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

const SwitchModeButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="fixed bottom-4 right-4  z-50 px-4 py-2 text-sm font-medium rounded-full bg-black/60 text-white backdrop-blur-sm hover:bg-black/80 transition"
  >
    Changer de mode d'affichage
  </button>
);

const App = () => {
  const [loading, setLoading] = useState(0);
  const [renderMode, setRenderMode] = useState(
    () => localStorage.getItem("renderMode"), // null | "3d" | "classic"
  );
  const windowSize = useWindowSize();

  const handleSelectRenderMode = (mode) => {
    localStorage.setItem("renderMode", mode);
    setRenderMode(mode);
  };

  const handleResetRenderMode = () => {
    localStorage.removeItem("renderMode");
    setRenderMode(null);
  };

  const isDesktop = windowSize.width >= 1024 && windowSize.height >= 500; // Réduit de 600 à 500
  const isTablet = windowSize.width >= 768 && windowSize.width < 1024;

  if (windowSize.width === undefined) {
    return (
      <div className="fixed inset-0 bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900 flex items-center justify-center">
        <div className="text-white text-xl">Chargement...</div>
      </div>
    );
  }

  if (isDesktop) {
    if (!renderMode) {
      return <RenderSelector onSelect={handleSelectRenderMode} />;
    }
    if (renderMode === "3d") {
      return (
        <Layout loading={loading}>
          <Canvas
            gl={{
              antialias: true,
              alpha: true,
              powerPreference: "high-performance",
              depth: true,
              stencil: false,
              preserveDrawingBuffer: false,
            }}
            dpr={[1, Math.min(2, window.devicePixelRatio)]}
            camera={{
              fov: 75,
              near: 0.1,
              far: 1000,
              position: [0, 0, 2],
            }}
            style={{
              background: "transparent",
              touchAction: "none",
            }}
          >
            <ThreeRender
              setLoading={(value) => setLoading(value)}
              loading={loading}
              onSwitchMode={handleResetRenderMode}
            />
          </Canvas>
        </Layout>
      );
    }
    return (
      <div className="flex justify-center min-w-full min-h-full bg-white">
        <Home />
        <SwitchModeButton onClick={handleResetRenderMode} />
      </div>
    );
  }
  return (
    <div className="flex justify-center min-w-full min-h-full bg-white">
      <Home />
      {isTablet && (
        <div className="fixed bottom-4 left-4 right-4 bg-blue-50 border border-blue-200 rounded-lg p-4 text-center z-50">
          <p className="text-blue-800 text-sm">
            💡 Pour une expérience 3D optimale, utilisez un écran plus large ou
            passez en mode paysage
          </p>
        </div>
      )}
    </div>
  );
};

export default App;
